import Logger from './Logger.vue'
export default {
  install: function (Vue) {
    Vue.component('logger', Logger)
  }
}